import { render, staticRenderFns } from "./NewMetadata.vue?vue&type=template&id=31d3694f&scoped=true&"
import script from "./NewMetadata.vue?vue&type=script&lang=js&"
export * from "./NewMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3694f",
  null
  
)

export default component.exports